var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerActiveIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.6914C11.0375 11.6914 10.2136 11.3487 9.52825 10.6634C8.84275 9.97791 8.5 9.15391 8.5 8.19141C8.5 7.22891 8.84275 6.40499 9.52825 5.71966C10.2136 5.03416 11.0375 4.69141 12 4.69141C12.9625 4.69141 13.7864 5.03416 14.4718 5.71966C15.1573 6.40499 15.5 7.22891 15.5 8.19141C15.5 9.15391 15.1573 9.97791 14.4718 10.6634C13.7864 11.3487 12.9625 11.6914 12 11.6914ZM4.5 19.3069V17.0837C4.5 16.594 4.633 16.1405 4.899 15.7232C5.165 15.3058 5.5205 14.985 5.9655 14.7607C6.95383 14.2762 7.95092 13.9127 8.95675 13.6704C9.96258 13.4281 10.977 13.3069 12 13.3069C13.023 13.3069 14.0374 13.4281 15.0433 13.6704C16.0491 13.9127 17.0462 14.2762 18.0345 14.7607C18.4795 14.985 18.835 15.3058 19.101 15.7232C19.367 16.1405 19.5 16.594 19.5 17.0837V19.3069H4.5Z",
    fill: "#3469E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerActiveIc);
export default __webpack_public_path__ + "static/media/customer_active_ic.c207060daf83f45a2a56108c3cea27eb.svg";
export { ForwardRef as ReactComponent };